import request from '../request'
import qs from 'query-string'

// 新增档案
export function addProjectApi(params: any) {
	return request.post('/api/health_manage/archival_records', params)
}

// 用户列表
export function getUserListApi(query: any) {
	let params = qs.stringify(query)
	return request.get(`/api/customer/customers?${params}`)
}

// 查看档案列表
export function getProjectListByNameApi(query: any) {
	let params = qs.stringify(query)
	return request.get(`/api/health_manage/archival_records?${params}`)
}

// 查看档案详情
export function getProjectDescApi(id: any) {
	return request.get(`/api/health_manage/archival_records/${id}`)
}

// 查看家族列表
export function getFalimyListApi(id: any) {
	return request.get(`/api/health_manage/archival_records/members?mobile=${id}`)
}

//导入档案
export function uploadProjectApi(fileData: any) {
	// const formData = new FormData()
  // formData.append("files", file)
  return request({
    url: "/api/health_manage/archival_records/import",
    method: "post",
    data: fileData,
    headers: {
      "Content-Type": "multipart/form-data",
    }
  })
}

// 健康记录成员列表
export function getHealthRecordApi(mobile: string) {
  return request.get(`/api/health_manage/health_records/members?mobile=${mobile}`)
}

// 健康记录列表
export function getHealthRecordListApi(params: any) {
  let query = qs.stringify(params)
  return request.get(`/api/health_manage/health_records?${query}`)
}


// 健康记录详情
export function getHealthRecordDescApi(id: number) {
  return request.get(`/api/health_manage/health_records/${id}`)
}

// 设置取消客户会员
export function setUserVipApi(params: any) {
  return request.put('/api/customer/wxupdate', params)
}

// 关系列表
export function getTypeListApi() {
  return request.get('/api/admin_user/family_member_list')
}